import "./App.css";
import { PrimeReactProvider } from "primereact/api";
import EditMultipleTransportationSchema from "./pages/EditMultipleTransportationSchema";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App({ Component, pageProps }) {
  return (
    <PrimeReactProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EditMultipleTransportationSchema />} />
        </Routes>
      </BrowserRouter>
      <div className="fixed bottom-0 left-0 right-0  md:px-8 flex justify-around text-xs md:text-lg md:justify-between items-center">
        <p>TERRA SOFTWARE INFORMATICS LLC.</p> <p>All right reserved</p>
      </div>
    </PrimeReactProvider>
  );
}

export default App;
